import TemplateFieldIcon from '@mui/icons-material/Web';
import TemplateFieldOrderList from '../templatefieldsorder/TemplateFieldOrderList';

export default {
  list: TemplateFieldOrderList,
  ICON: TemplateFieldIcon
};